<template>
  <div class="tab-content_description tab-description">
    <div class="tab-description__container page-container">
      <div class="tab-description__row">
        <div class="tab-description__half-wrapper tab-description__half-wrapper--gallery">
          <photo-gallery></photo-gallery>
          <product-panel-info />
          <product-card-characteristics
            class="product__short-characteristics"
            v-if="shortCharacteristics.length"
            size="medium"
            :values="shortCharacteristics"
            product-page
          ></product-card-characteristics>
          <expert-callback
            v-if="isExpertBlockVisible && abExpertBlockVisibility === 1"
            :product-id="productId"
          ></expert-callback>
        </div>
        <div class="tab-description__half-wrapper">
          <product-counters class="product__stats" :counters="statsCounters" ></product-counters>
          <rendered-blocks
            uid="countdown_product"
            :product-id="productId"
            :product-sku="code"
            without-top-margin
            without-container
          ></rendered-blocks>
          <product-badge-description></product-badge-description>
          <product-in-stock></product-in-stock>
          <product-options v-if="options.length" :options="options"></product-options>
          <div class="product__actions product-actions" :data-productKey="code">
            <div v-if="price" class="product-actions__price-wrap">
              <product-price
                :old-price="oldPrice"
                :price="price"
                vertical
                size="medium"
              ></product-price>
              <bonus-info v-if="!config.happy_hours" class="product__actions__bonus-info"></bonus-info>
            </div>
            <div ref="btnBuy" class="product-actions__btns-wrap">
              <buy-btn
                v-if="inStock || availableInStore"
                size="medium"
                :price="price"
                :code="code"
                :title-analytics="title"
                :product-id="productId"
                :store-id="availableInStore ? availableStoreId : ''"
                :stores-data="storesData"
                :available-in-store="availableInStore"
                product-page
                class="product-actions__btn product-actions__btn--buy"
              ></buy-btn>
              <!--              <buy-btn-->
              <!--                v-else-if="isNovelty"-->
              <!--                pre-order-btn-->
              <!--                size="medium"-->
              <!--                :title-ru="titleRu"-->
              <!--                :product-id="productId"-->
              <!--                :code="code"-->
              <!--                product-page-->
              <!--                :price="price"-->
              <!--                class="product-actions__btn product-actions__btn&#45;&#45;pre-order"-->
              <!--              ></buy-btn>-->
              <buy-btn
                v-else-if="isPreorder && !isArchive"
                pre-order-btn
                size="medium"
                :title-analytics="titleAnalytics"
                :product-id="productId"
                :code="code"
                product-page
                :price="price"
                class="product-actions__btn product-actions__btn--pre-order"
              ></buy-btn>
              <wait-list-btn
                v-else
                :in-wait-list-status="isInWaitList"
                :product-id="productId"
                product-page
                class="product-actions__btn product-actions__btn--wait-list"
              ></wait-list-btn>
              <buy-btn
                v-if="inStock && !isManager && config.isEnabledOneClickAndCallback"
                type="invert"
                size="medium"
                :title-analytics="title"
                :product-id="productId"
                :code="code"
                :price="price"
                one-click-btn
                product-page
                class="product-actions__btn product-actions__btn--one-click"
              ></buy-btn>
              <a v-if="allegroLink"
                 @click="handleAllegroRedirect($event, allegroLink)"
                 :href="allegroLink"
                 target="_blank"
                 class="allegro-btn">
                {{ $t('allegro.buy-btn') }}
                <svg width="50"
                     height="22"
                     viewBox="0 0 50 22"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M47.9131 8.90175C48.0515 9.10823 48.1741 9.32567 48.2802 9.5522C48.386 9.77842 48.4747 10.0134 48.5458 10.2544C48.6165 10.495 48.6692 10.7416 48.7034 10.991C48.7376 11.2404 48.7529 11.4923 48.7496 11.7442C48.7529 11.9964 48.7376 12.2483 48.7034 12.4977C48.6692 12.7471 48.6165 12.9937 48.5458 13.2344C48.4747 13.4753 48.386 13.71 48.2802 13.9365C48.1741 14.163 48.0515 14.3805 47.9131 14.5866C47.4968 15.1475 46.9633 15.6015 46.353 15.9136C45.7431 16.2256 45.073 16.3879 44.3938 16.3879C43.7146 16.3879 43.0445 16.2256 42.4346 15.9136C41.8243 15.6015 41.2908 15.1475 40.8745 14.5866C40.7361 14.3805 40.6135 14.163 40.5074 13.9365C40.4016 13.7103 40.3126 13.4753 40.2418 13.2347C40.1708 12.9937 40.1181 12.7471 40.0839 12.4977C40.05 12.2483 40.0344 11.9964 40.038 11.7442C40.0344 11.4923 40.05 11.2404 40.0839 10.991C40.1181 10.7413 40.1708 10.495 40.2418 10.254C40.3126 10.0131 40.4016 9.77842 40.5074 9.5522C40.6135 9.32567 40.7361 9.10823 40.8745 8.90175C41.2908 8.34122 41.8243 7.88722 42.4346 7.57515C43.0445 7.26308 43.7146 7.10078 44.3938 7.10078C45.073 7.10078 45.7431 7.26308 46.353 7.57515C46.9633 7.88722 47.4968 8.34122 47.9131 8.90175ZM46.5191 12.8067C46.5748 12.6356 46.6171 12.4601 46.6453 12.2819C46.6734 12.1036 46.6878 11.9231 46.6878 11.7426C46.6878 11.5618 46.6734 11.3814 46.6453 11.2031C46.6171 11.0251 46.5748 10.8494 46.5191 10.6783C46.1993 9.68004 45.4377 8.85225 44.3905 8.877C43.343 8.90175 42.585 9.68004 42.2652 10.6783C42.2092 10.8497 42.1666 11.0254 42.1384 11.204C42.11 11.3826 42.0956 11.5634 42.0956 11.7442C42.0956 11.9253 42.11 12.1061 42.1384 12.2847C42.1666 12.4633 42.2092 12.639 42.2652 12.8101C42.5814 13.8087 43.3397 14.6365 44.3905 14.6117C45.441 14.5866 46.1993 13.8087 46.5191 12.8101V12.8067ZM14.472 16.1501C14.472 16.1846 14.4654 16.2187 14.4528 16.2507C14.4399 16.2826 14.4216 16.3118 14.3983 16.3359C14.3749 16.3604 14.347 16.3798 14.3164 16.3929C14.2859 16.4064 14.2532 16.413 14.2202 16.413H12.7582C12.725 16.413 12.6923 16.4064 12.6617 16.3929C12.6314 16.3798 12.6036 16.3604 12.5802 16.3359C12.5568 16.3118 12.5382 16.2826 12.5256 16.2507C12.5131 16.2187 12.5065 16.1846 12.5065 16.1501V3.59002C12.5065 3.55556 12.5131 3.52141 12.5256 3.48945C12.5382 3.45749 12.5568 3.42866 12.5802 3.40423C12.6036 3.37979 12.6314 3.36036 12.6617 3.3472C12.6923 3.33404 12.725 3.32715 12.7582 3.32715H14.2202C14.2532 3.32715 14.2859 3.33404 14.3164 3.3472C14.347 3.36036 14.3749 3.37979 14.3983 3.40423C14.4216 3.42866 14.4399 3.45749 14.4528 3.48945C14.4654 3.52141 14.472 3.55556 14.472 3.59002V16.1501ZM11.0376 16.1501C11.0376 16.1846 11.0313 16.2187 11.0184 16.2507C11.0058 16.2826 10.9872 16.3118 10.9638 16.3359C10.9404 16.3604 10.9129 16.3798 10.8823 16.3929C10.8517 16.4064 10.8191 16.413 10.7861 16.413H9.32378C9.29081 16.413 9.25815 16.4064 9.22757 16.3929C9.197 16.3798 9.16943 16.3604 9.14605 16.3359C9.12267 16.3118 9.10409 16.2826 9.0915 16.2507C9.07892 16.2187 9.07232 16.1846 9.07232 16.1501V3.59002C9.07232 3.55587 9.07862 3.52203 9.0912 3.49039C9.10349 3.45874 9.12178 3.42992 9.14485 3.40548C9.16793 3.38104 9.19521 3.36161 9.22518 3.34814C9.25545 3.33467 9.28782 3.32746 9.32049 3.32715H10.7825C10.8158 3.32715 10.8484 3.33404 10.879 3.3472C10.9096 3.36036 10.9372 3.37979 10.9605 3.40423C10.9839 3.42866 11.0025 3.45749 11.0151 3.48945C11.0277 3.52141 11.0343 3.55556 11.0343 3.59002V16.1501H11.0376ZM39.7083 8.68869C39.7143 8.73475 39.7089 8.78144 39.6931 8.82499C39.6772 8.86823 39.6511 8.90676 39.6172 8.93684C39.5834 8.96692 39.5429 8.9876 39.4994 8.997C39.456 9.0064 39.4107 9.00421 39.3682 8.99073C37.7158 8.63543 36.6992 9.40275 36.6992 10.9982V16.1501C36.6992 16.1846 36.6926 16.2187 36.68 16.2507C36.6674 16.2826 36.6488 16.3118 36.6255 16.3359C36.6021 16.3604 36.5742 16.3798 36.5436 16.3929C36.5134 16.4064 36.4804 16.413 36.4474 16.413H34.9854C34.9525 16.413 34.9195 16.4064 34.8892 16.3929C34.8586 16.3798 34.8308 16.3604 34.8074 16.3359C34.784 16.3118 34.7654 16.2826 34.7528 16.2507C34.7403 16.2187 34.7337 16.1846 34.7337 16.1501V10.8882C34.7295 10.6397 34.7499 10.3919 34.7951 10.1481C34.8401 9.90438 34.9096 9.66625 35.0022 9.43784C35.0948 9.20912 35.2099 8.99136 35.346 8.7877C35.4821 8.58436 35.6382 8.39636 35.8117 8.22686C35.9883 8.04639 36.1813 7.8844 36.3878 7.7434C36.5946 7.6021 36.814 7.48241 37.0427 7.38559C37.2717 7.28909 37.509 7.21577 37.7518 7.16752C37.9943 7.11896 38.2406 7.09546 38.4876 7.09702C38.573 7.09734 38.6584 7.09953 38.7439 7.1036C38.8293 7.10799 38.9147 7.11426 38.9998 7.12272C39.0849 7.13086 39.1698 7.1412 39.2546 7.15342C39.3391 7.16595 39.4236 7.18005 39.5075 7.19635C39.6811 7.25682 39.7083 7.36335 39.7083 7.63688V8.68869ZM33.4452 11.7407V16.1501C33.4476 16.3068 33.4443 16.4634 33.4353 16.6198C33.4263 16.7758 33.4119 16.9318 33.3915 17.0869C33.3715 17.2423 33.3457 17.3965 33.3142 17.5497C33.2827 17.7026 33.2459 17.8546 33.2036 18.005C33.1476 18.1977 33.0744 18.3847 32.9851 18.5636C32.8958 18.7425 32.7909 18.9123 32.6716 19.0709C32.5523 19.2294 32.4193 19.3761 32.2742 19.5089C32.1288 19.6418 31.9724 19.7605 31.806 19.863C30.8473 20.4351 29.5723 20.4705 27.6784 20.3C27.6493 20.3016 27.6202 20.2969 27.5929 20.2866C27.5657 20.2762 27.5405 20.2606 27.5189 20.2402C27.4976 20.2195 27.4799 20.1948 27.4677 20.1675C27.4554 20.1399 27.4485 20.1102 27.447 20.0798V18.7297C27.447 18.4775 27.6034 18.4417 27.8279 18.4775C27.967 18.4981 28.1064 18.5157 28.246 18.5301C28.3857 18.5445 28.5257 18.5558 28.6656 18.5639C28.8059 18.5718 28.9462 18.5768 29.0867 18.5783C29.227 18.5799 29.3673 18.578 29.5075 18.5733C30.3237 18.5201 31.5986 18.2428 31.5986 16.7185V15.5958C31.4146 15.7243 31.2216 15.8384 31.0214 15.9371C30.8209 16.0354 30.6141 16.1185 30.4019 16.1852C30.19 16.2519 29.9736 16.3024 29.7545 16.3356C29.5354 16.3691 29.3142 16.3854 29.0927 16.3848C28.7534 16.3898 28.4151 16.3531 28.0839 16.2754C27.7527 16.1977 27.4317 16.0799 27.1269 15.9239C26.8224 15.7679 26.5361 15.5752 26.2745 15.3493C26.0128 15.1237 25.7776 14.8664 25.5735 14.5832C25.2989 14.168 25.0858 13.7115 24.942 13.2297C24.7981 12.7474 24.725 12.2455 24.725 11.7407C24.725 11.236 24.7981 10.7341 24.942 10.2522C25.0858 9.76996 25.2989 9.31377 25.5735 8.8983C25.9901 8.33746 26.5236 7.88377 27.1335 7.5717C27.7434 7.25932 28.4136 7.09702 29.0927 7.09702C29.7719 7.09702 30.4423 7.25932 31.0523 7.5717C31.6622 7.88377 32.1957 8.33746 32.612 8.8983C32.7513 9.10416 32.8748 9.32129 32.9815 9.5475C33.0879 9.77372 33.1769 10.0087 33.248 10.2497C33.3187 10.4906 33.3715 10.7372 33.405 10.9869C33.4386 11.2366 33.453 11.4885 33.4485 11.7407H33.4452ZM31.5204 11.7373C31.5204 11.3748 31.4425 8.86979 29.0927 8.86979C28.0422 8.86979 27.2839 9.67283 26.9641 10.6714C26.9081 10.8425 26.8658 11.0185 26.8374 11.1968C26.8089 11.3754 26.7945 11.5562 26.7945 11.7373C26.7945 11.9184 26.8089 12.0989 26.8374 12.2775C26.8658 12.4561 26.9081 12.6318 26.9641 12.8032C27.2839 13.8015 28.0422 14.6045 29.0927 14.6045C31.4425 14.6045 31.5204 12.0995 31.5204 11.7373ZM7.73589 10.8099V16.1395C7.73589 16.1739 7.7296 16.2081 7.71701 16.24C7.70412 16.272 7.68554 16.3008 7.66246 16.3253C7.63908 16.3497 7.61121 16.3691 7.58064 16.3823C7.55007 16.3954 7.5174 16.4023 7.48443 16.4023H3.18321C2.9827 16.4142 2.78159 16.4086 2.58228 16.3854C2.38267 16.3622 2.18546 16.3215 1.99244 16.2638C1.79942 16.2062 1.6115 16.1316 1.43048 16.0414C1.24945 15.9508 1.07591 15.8446 0.911668 15.7237C0.760611 15.594 0.62484 15.4464 0.506752 15.2835C0.388664 15.1209 0.289158 14.9441 0.210633 14.7571C0.132107 14.57 0.0748618 14.3739 0.0400948 14.1731C0.00502809 13.9719 -0.00696053 13.7673 0.00382923 13.5636V13.5351C0.00382923 10.8453 2.80557 10.49 3.7203 10.49H5.84558V10.2948C5.85008 10.1663 5.83779 10.0375 5.80902 9.91252C5.78025 9.78751 5.73559 9.66719 5.67595 9.55471C5.6163 9.44223 5.54227 9.33852 5.45625 9.24703C5.36994 9.15523 5.27193 9.07627 5.16553 9.01204C4.38687 8.60002 2.85682 8.75261 1.58153 9.57351C1.55126 9.60108 1.5141 9.61988 1.47453 9.62771C1.43497 9.63555 1.39391 9.63241 1.35585 9.61832C1.31778 9.60422 1.28391 9.57978 1.25784 9.5475C1.23206 9.51523 1.21468 9.47638 1.20749 9.43471L1.12926 8.09902C1.12926 8.08179 1.13106 8.06487 1.13526 8.04827C1.13915 8.03166 1.14545 8.01568 1.15354 8.00064C1.16133 7.98591 1.17122 7.97213 1.18261 7.95991C1.1943 7.94769 1.20719 7.93704 1.22127 7.92826C1.44606 7.7926 1.67924 7.67228 1.91901 7.56857C2.15908 7.46486 2.40515 7.37776 2.65601 7.30789C2.90717 7.23802 3.16223 7.18569 3.41969 7.15091C3.67714 7.11645 3.9367 7.09953 4.19625 7.10047C5.23686 7.10047 6.359 7.41661 6.91647 8.05265C7.47424 8.68869 7.73259 9.60892 7.73259 10.8205L7.73589 10.8099ZM5.84558 12.1174H3.83599C2.28886 12.1174 1.97955 13.0767 1.97955 13.5564C1.97806 13.6417 1.98645 13.7266 2.00473 13.8096C2.02301 13.8926 2.05089 13.9728 2.08775 14.0487C2.12462 14.1248 2.17017 14.1956 2.22382 14.2598C2.27717 14.3244 2.33771 14.3814 2.40455 14.4303C2.46899 14.4814 2.53732 14.5271 2.60866 14.5669C2.67999 14.6067 2.75402 14.6408 2.83045 14.669C2.90657 14.6969 2.9851 14.7189 3.06452 14.7342C3.14395 14.7496 3.22457 14.7583 3.3055 14.7608H5.84558V12.1174ZM19.8543 7.10047C23.4077 7.10047 23.8666 10.5718 23.7647 12.2239C23.7641 12.2565 23.7578 12.2884 23.7455 12.3182C23.7335 12.348 23.7158 12.3749 23.6936 12.3975C23.6718 12.4203 23.6457 12.4382 23.6169 12.4504C23.5881 12.463 23.5576 12.4692 23.5267 12.4692H17.7464C17.7767 12.7603 17.8576 13.0432 17.9847 13.3045C18.112 13.5655 18.2835 13.8002 18.4909 13.9973C18.6983 14.1941 18.9384 14.3501 19.1991 14.4576C19.4599 14.565 19.7374 14.622 20.0176 14.6258C20.2637 14.6512 20.5113 14.6549 20.7576 14.6371C21.0043 14.6195 21.2492 14.5801 21.4895 14.5196C21.7296 14.4594 21.9649 14.3783 22.1924 14.2768C22.4196 14.1756 22.6383 14.0546 22.8466 13.9152C23.0472 13.7695 23.1865 13.8832 23.1865 14.1248V15.3079C23.1967 15.3499 23.2006 15.3931 23.1979 15.4364C23.1952 15.4796 23.1862 15.5219 23.1712 15.5623C23.156 15.6024 23.135 15.64 23.1086 15.6736C23.0825 15.7068 23.0514 15.7359 23.0166 15.7594C22.2991 16.1855 21.3607 16.4343 19.9565 16.381C19.6181 16.3807 19.2806 16.34 18.9509 16.2601C18.6213 16.1799 18.3015 16.0611 17.9975 15.9054C17.6936 15.75 17.4077 15.5586 17.1449 15.3355C16.8823 15.1124 16.6449 14.8589 16.4372 14.5797C16.2988 14.3733 16.1762 14.1558 16.0701 13.9293C15.9643 13.7031 15.8753 13.4684 15.8045 13.2275C15.7335 12.9865 15.6807 12.7402 15.6469 12.4905C15.6127 12.2411 15.5971 11.9892 15.6007 11.7373C15.6004 11.6301 15.6034 11.523 15.6097 11.4162C15.616 11.3093 15.6253 11.2028 15.6379 11.0962C15.6502 10.99 15.6658 10.8841 15.6846 10.7789C15.7035 10.6736 15.7254 10.5692 15.7503 10.4652C16.1141 8.92306 17.2534 7.10047 19.8543 7.10047ZM21.7074 10.8346C21.726 10.5749 21.6909 10.3139 21.6049 10.0692C21.5186 9.82479 21.3834 9.60234 21.2084 9.41685C21.0331 9.23136 20.8218 9.08724 20.5889 8.99418C20.356 8.90112 20.1066 8.86102 19.8579 8.877C19.5977 8.86071 19.337 8.89862 19.0912 8.98854C18.8451 9.07846 18.6189 9.21852 18.4252 9.40087C18.2316 9.58291 18.0746 9.80349 17.9631 10.0498C17.8519 10.296 17.7886 10.5627 17.777 10.8346H21.7074Z"
                        fill="#FF5A00"/>
                </svg>
              </a>
            </div>
            <div class="product-actions__btns-wrap">
              <add-to-comparison-btn
                class="product-actions__btn product-actions__btn--comparison"
                product-page
                :title-analytics="title"
                :product-id="productId"
              ></add-to-comparison-btn>
              <wish-list-btn
                class="product-actions__btn product-actions__btn--wish-list"
                product-page
                :analytics-data="analyticsData"
                :code="code"
                :id="productId"
                :in-wish-list-status="inWishListStatus"
              ></wish-list-btn>
            </div>
          </div>
          <expert-callback
            v-if="isExpertBlockVisible"
            :product-id="productId"
          ></expert-callback>
          <div class="product__rendered-block" v-if="!inStock && !availableInStore">
            <rendered-blocks
              uid="product_page_under_price"
              :product-id="productId"
              :product-sku="code"
              is-product-page-under-price
              without-container
            ></rendered-blocks>
          </div>
          <ProductRecommendations
            v-if="conditionProductRecommendations"
            class="product-description__product-recommendations"
            :products="setsWithProduct"
            :title="$t('product-sets__title')"
          />
          <product-details class="product__details"></product-details>
        </div>
      </div>
      <div class="tab-description__row">
        <div class="tab-description__wrapper">
          <rendered-blocks
            uid="product_page_description"
            :product-id="productId"
            :product-sku="code"
            without-container
          ></rendered-blocks>
          <div v-if="descriptions && descriptions.length > 0" class="tab-description__container product-description-wrapper">
            <div
              class="tab-description__wrapper page-container"
              :class="{
          'tab-description__wrapper--single': descriptions.length === 1,
          'tab-description__wrapper--full': descriptions[0].html_description
        }"
            >
              <with-title
                v-if="descriptions && descriptions.length >= 1 && Object.values(descriptions[0])[0].length"
                :title="$t('description')"
                :subtitle="title"
                :with-container="descriptions[0].html_description"
              >
                <product-descriptions />
              </with-title>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-description__row" v-if="computedCombinedProducts.length">
        <div class="tab-description__wrapper">
          <products-slider
            :title="$t('combined_products_block_title')"
            :title-analytics="'cross-sale'"
            :products="computedCombinedProducts"
            :link="computedCombinedProductsLink"
            @link-click="goToCombinedProductsTab"
            link-click-prevent
            without-container
          ></products-slider>
        </div>
      </div>
      <!--      <div class="tab-description__row" v-if="setsWithProduct.length">-->
      <!--        <div class="tab-description__wrapper">-->
      <!--          <sets-with-product-->
      <!--            :title="$t('sets_with_product_title')"-->
      <!--            :product-id="productId"-->
      <!--            :sets-with-product="setsWithProduct"-->
      <!--          ></sets-with-product>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="tab-description__row" v-if="buyTogether">
        <products-buy-together
          class="tab-description__wrapper"
          :data="buyTogether"
          :product-id="productId"
          :title="$t('joints')"
          without-container
        ></products-buy-together>
      </div>
      <div class="tab-description__row">
        <div class="tab-description__wrapper">
          <rendered-blocks
            uid="product_page_above_characteristics"
            :product-id="productId"
            :product-sku="code"
            without-container
          ></rendered-blocks>
        </div>
      </div>
      <div class="tab-description__half-wrapper mt-fix">
        <with-title
          v-if="characteristics && characteristics.length >= 1 && Object.values(characteristics[0])[0].length"
          :title="$t('tab.characteristic')"
        >
          <product-full-characteristics description></product-full-characteristics>
          <dashed-link
            class="tab-description__link"
            :label="$t('all.characteristics')"
            tab-name="characteristics"
          ></dashed-link>
        </with-title>
        <div v-if="instruction" class="tab-description__instruction">
          <with-title :title="$t('some.materials')">
            <template v-for="(item, i) in instruction">
              <product-instruction :key="`pdf-instruction-${i}`" :instruction="item"></product-instruction>
            </template>
            <dashed-link
              v-if="instructions.length"
              class="tab-description__link"
              :label="$t('all_additional_materials')"
              tab-name="instructions"
            ></dashed-link>
          </with-title>
        </div>
      </div>
      <div class="tab-description__half-wrapper mt-fix">
        <add-comment-button
          class="add-comment-btn"
          type="pseudo-link"
          :post-comment-endpoint="$constants.COMMENTS.ADD_PRODUCT_COMMENT_ENDPOINT"
          :form-type="$constants.COMMENTS.FORM_TYPE_PRODUCT"
          :product-id="productId"
        ></add-comment-button>
        <with-title :title="$t('comment')" :subtitle="commentsCount ? commentsCount.toString() : ''">
          <empty-reviews
            v-if="!commentsCount"
            :type="$constants.COMMENTS.FORM_TYPE_PRODUCT"
            :endpoint="$constants.COMMENTS.ADD_PRODUCT_COMMENT_ENDPOINT"
            :product-id="productId"
          ></empty-reviews>
          <div v-else>
            <comments-list
              is-short
              :endpoint="$constants.COMMENTS.ADD_PRODUCT_COMMENT_ENDPOINT"
              :product-id="+productId"
            ></comments-list>
            <dashed-link class="tab-description__link" :label="$t('all.reviews')" tab-name="comments"></dashed-link>
          </div>
        </with-title>
      </div>
    </div>
    <!--    <script v-html="json_ld_rating" type="application/ld+json"></script>-->
  </div>
</template>

<script>
import api from '@/api'
import { GoogleEnhancedEcommerce, EsputnikService } from '@/services/AnalyticService'
import { mapGetters, mapState, mapActions } from 'vuex'
import ProductRecommendations from '@/components/product/product-page/ProductRecommendations'
import WithTitle from '../layouts/WithTitle'
import PhotoGallery from '../../../components/product/product-page/photo-gallery/PhotoGallery'
import ProductInStock from '../../../components/product/ProductInStock'
import AddToComparisonBtn from '../../../components/product/product-comparison/AddToComparisonBtn'
import WishListBtn from '../../../components/product/WishListBtn'
import BuyBtn from '../../../components/cart/BuyBtn'
import WaitListBtn from '../../../components/product/product-page/WaitListBtn'
import ProductCardCharacteristics from '../../../components/product/ProductCardCharacteristics'
import ProductDetails from '../../../components/product/product-page/ProductDetails'
import ProductFullCharacteristics from '../../../components/product/product-page/ProductFullCharacteristics'
import ProductInstruction from '../../../components/product/product-page/ProductInstruction'
import ProductDescriptions from '../../../components/product/product-page/ProductDescriptions'
import ProductBadgeDescription from '../../../components/product/product-page/ProductBadgeDescription'
import EmptyReviews from '../../../components/product/product-page/EmptyReviews'
import CommentsList from '../../../components/comments/CommentsList'
import DashedLink from '../../../components/product/product-page/DashedLink'
import { debounce, isAdaptiveMode } from '../../../mixins'
import ProductOptions from '../../../components/product/product-options/ProductOptions'
// import SetsWithProduct from '../../../components/product/product-page/SetsWithProduct'
import BonusInfo from '../../../components/product/product-page/BonusInfo'
import ProductPrice from '../../../components/product/ProductPrice'
import ProductsBuyTogether from '../../../components/product/product-block/ProductsBuyTogether'
import ProductPanelInfo from '@/components/product/product-page/ProductPanelInfo'
// import ProductSale from '../../../components/product/product-page/ProductSale'
import AddCommentButton from '../../../components/comments/AddCommentButton'
import checkNodeVisibilityInViewPort from '@/helpers/checkNodeVisibilityInViewport'
import ProductsSlider from '../../../components/product/product-block/ProductsSlider'
// import ProductCountdown from '@/components/product/product-page/ProductCountdown'
// import ProductStats from '@/components/product/product-page/ProductStats'
import ProductCounters from '@/components/product/product-page/ProductCounters'
import RenderedBlocks from '@/components/rendered-blocks/RenderedBlocks'
import ExpertCallback from '@/components/product/expert-callback/ExpertCallback'

export default {
  name: 'ProductDescription',
  data () {
    return {
      isBtnInViewport: false,
      timerVisible: true
    }
  },
  mixins: [debounce, isAdaptiveMode],
  components: {
    ProductRecommendations,
    RenderedBlocks,
    ProductPanelInfo,
    // ProductCountdown,
    // ProductStats,
    ProductCounters,
    ExpertCallback,
    // ProductCountdown,
    ProductsSlider,
    // ProductSale,
    ProductsBuyTogether,
    BonusInfo,
    // SetsWithProduct,
    ProductOptions,
    EmptyReviews,
    ProductBadgeDescription,
    WithTitle,
    ProductDescriptions,
    ProductInstruction,
    ProductFullCharacteristics,
    ProductDetails,
    PhotoGallery,
    ProductInStock,
    AddToComparisonBtn,
    WishListBtn,
    ProductCardCharacteristics,
    CommentsList,
    DashedLink,
    ProductPrice,
    BuyBtn,
    WaitListBtn,
    AddCommentButton
  },
  props: {
    statsCounters: Array
  },
  computed: {
    // TODO: remove it
    isHalloweenDate () {
      return (new Date().getTime() / 1000) > 1667077200
    },
    ...mapGetters(['isManager', 'urlLanguagePrefix']),
    ...mapState({
      auth: state => state.user.auth,
      title: state => state.productInfo.productInfo.title,
      allegroLink: state => state.productInfo.productInfo.allegroLink,
      productId: state => state.productInfo.productInfo.productId,
      titleAnalytics: state => state.productInfo.productInfo.title,
      inStock: state => state.productInfo.productInfo.inStock,
      isNovelty: state => state.productInfo.productInfo.isNovelty,
      isPreorder: state => state.productInfo.productInfo.isPreorder,
      isInWaitList: state => state.productInfo.productInfo.isInWaitList,
      inWishListStatus: state => state.productInfo.productInfo.inWishListStatus,
      code: state => state.productInfo.productInfo.code,
      analyticsData: state => state.productInfo.productInfo.analyticsData,
      shortCharacteristics: state => state.productInfo.productInfo.shortCharacteristics,
      commentsCount: state => state.comments.comments.total_count,
      instruction: state => state.productInfo.productInfo.instruction,
      instructions: state => state.productInfo.productInfo.instructions,
      descriptions: state => state.productInfo.productInfo.descriptions,
      characteristics: state => state.productInfo.productInfo.characteristics,
      options: state => state.productInfo.productInfo.options,
      isSale: state => state.productInfo.productInfo.isSale,
      countdownTill: state => state.productInfo.productInfo.countdownTill,
      countdownEnabled: state => state.productInfo.productInfo.countdownEnabled,
      setsWithProduct: state => state.productInfo.setsWithProduct,
      price: state => state.productInfo.productInfo.price,
      oldPrice: state => state.productInfo.productInfo.oldPrice,
      buyTogether: state => state.products.buyTogether,
      // availableInStore: state => state.productInfo.productInfo.availableInStore,
      combinedProducts: state => state.productInfo.productInfo.combinedProducts,
      initialOffset: state => state.productTabs.initialOffset,
      abExpertBlockVisibility: state => state.abTesting.dataFromCookies?.technicalExpertBlockVisibility,
      config: state => state.init.config,
      isArchive: state => state.productInfo.productInfo.isArchive,
      language: state => state.translation?.language,
      rating: state => state.productInfo.rating,
      userStore: state => state.geoLocation.userStore,
      storesData: state => state.productInfo.productInfo.storesData,
      maxAvailableQuantity: state => state.productInfo.productInfo.maxAvailableQuantity,
      baseProductCode: state => state.productInfo.productInfo.esputnikData.productKey,
      recommendedProducts: state => state.productInfo.recommendedProducts
    }),
    conditionProductRecommendations () {
      return this.inStock && this.setsWithProduct && this.setsWithProduct.length
    },
    availableInStore () {
      return !this.maxAvailableQuantity && this.storesData.find(el => +el.quantity > 0)
    },
    availableStoreId () {
      if (this.userStore && this.userStore.id) {
        const store = this.storesData.find(el => +el.id === +this.userStore.id)
        return store ? +store.id : null
      }
      return null
    },
    // json_ld_rating () {
    //   return {
    //     '@context': 'https://schema.org/',
    //     '@type': 'AggregateRating',
    //     'ratingValue': this.rating,
    //     'reviewCount': this.commentsCount
    //   }
    // },
    computedCombinedProducts () {
      return this.combinedProducts?.products?.map(item => {
        item.id = +item.id
        item.code = item.code.toString()
        item.title_analytics = item.title_anal
        item.image_url = item.photos.image_url
        item.second_image_url = item.photos.image_url_additional
        item.mobile_image_url = item.photos.image_url_small
        item.rating = item.rating ? item.rating : ''
        item.reviews_count = +item.reviews_count
        item.price = { 'price_new': +item.price_new, 'price_old': +item.price_old }
        item.is_available = !!+item.is_available
        item.is_novelty = !!+item.is_novelty
        item.is_in_wait_list = !!+item.is_in_wait_list
        item.is_in_wish_list = !!+item.is_in_wish_list

        return item
      }).slice(0, 15) ?? []
    },
    computedCombinedProductsLink () {
      return location.origin + location.pathname + '?tab=combined=products'
    },
    isExpertBlockVisible () {
      return this.config?.isEnabledTechnicalExpert && this.inStock
    },
    imageCacheKey () {
      return ('?t=' + Math.ceil((+new Date()) / 1000 / 60))
    },
    isTradeIn () {
      const tradeInProducts = [554, 939, 970, 971, 1125, 1126, 1127, 1144, 1145, 1146, 1147, 1148, 1149, 1209, 1340, 1342, 1343, 1344, 1347, 1348, 1349, 1380, 1381, 1382, 1421, 1422, 1423, 1424, 1425, 1426, 1427, 1428, 1429, 1430, 1432, 1433, 1434, 1435, 1495, 1496, 1497, 1519, 1520, 1521, 1522, 1523, 1524, 1525, 1621, 1699, 1751, 1752, 1754, 1755, 1756, 1758, 1760, 1761, 1773, 1774, 1775, 1776, 1778, 1779, 1780, 1781, 1782, 1783, 1784, 1785, 1788, 1789, 1793, 1836, 1837, 1838, 1839, 1840, 1841, 1842, 1843, 1889, 1890, 1945, 1994, 1995, 1996, 1997, 1998, 1999, 2005, 2006, 2008, 2009, 2010, 2012, 2014, 2015, 2020, 2021, 2022, 2023, 2024, 2144, 2151, 2192, 2193, 2194, 2195, 2196, 2236, 2242, 2259, 2260, 2261, 2262, 2263, 2264, 2265, 2266, 2267, 2268, 2269, 2270, 2271, 2272, 2273, 2274, 2275, 2276, 2279, 2298, 2299, 2300, 2301, 2302, 2311, 2321, 2322, 2323, 2327, 2328, 2334, 2335, 2336, 2337, 2338, 2390, 2391, 2392, 2393, 2394, 2395, 2396, 2397, 2399, 2413, 2414, 2421, 2422, 2423, 2424, 2425, 2431, 2432, 2433, 2440, 2445, 2447, 2453, 2454, 2455, 2456, 2457, 2458, 2459, 2460, 2461, 2462, 2463, 2464, 2465, 2466, 2469, 2470, 2475, 2476, 2477, 2517, 2518, 2524, 2525, 2527, 2528, 2529, 2530, 2531, 2532, 2533, 2534, 2535, 2538, 2539, 2540, 2541, 2543, 2549, 2550, 2551, 2559, 2563, 2564, 2565, 2568, 2569, 2570, 2571, 2572, 2573, 2580, 2582, 2583, 2584, 2585, 2586, 2587, 2588, 2589, 2590, 2591, 2592, 2593, 2594, 2595, 2601, 2602, 2603, 2604, 2605, 2608, 2616, 2620, 2641, 2642, 2658, 2659, 2660, 2661, 2662, 2665, 2666, 2667, 2671, 2673, 2674, 2675, 2679, 2681, 2682, 2684, 2685, 2686, 2687, 2688, 2689, 2690, 2694, 2695, 2696, 2697, 2728, 2729, 2730, 2731, 2732, 2762, 2770, 2772, 2775, 2776, 2777, 2778, 2781, 2782, 2784, 2785, 2786, 2788, 2789, 2790, 2791, 2792, 2796, 2797, 2798, 2799, 2800, 2801, 2802, 2803, 2804, 2805, 2806, 2807, 2808, 2809, 2810, 2811, 2824, 2825, 2826, 2827, 2828, 2829, 2830, 2831, 2832, 2833, 2834, 2835, 2836, 2837, 2838, 2839, 2844, 2859, 2881, 2897, 2898, 2899, 2900, 2901, 2902, 2906, 2918, 2919, 2920, 2921, 2922, 2923, 2925, 2926, 2927, 2928, 2929, 2961, 2962, 2963, 2964, 2970, 2972, 2973, 2975, 2981, 2982, 2983, 2984, 2986, 2987, 2988, 2989, 2998, 2999, 3000, 3001, 3002, 3009, 3010, 3011, 3012, 3013, 3014, 3015, 3016, 3017, 3018, 3019, 3020, 3021, 3022, 3037, 3038, 3039, 3045, 3067, 3068, 3069, 3070, 3071, 3072, 3074, 3076, 3077, 3079, 3080, 3082, 3083, 3084, 3086, 3101, 3102, 3103, 3104, 3105, 3108, 3110, 3112, 3113, 3114, 3115, 3116, 3117, 3124, 3125, 3126, 3127, 3128, 3129, 3130, 3131, 3132, 3133, 3134, 3153, 3154, 3157, 3176, 3177, 3218, 3246, 3252, 3253, 3254, 3255, 3257, 3258, 3259, 3260, 3261, 3262, 3279, 3280, 3281, 3282, 3284, 3288, 3294, 3295, 3296, 3297, 3298, 3303, 3308, 3310, 3311, 3312, 3313, 3314, 3321, 3324, 3380, 3381, 3382, 3385, 3444, 3446, 3447, 3448, 3449, 3457, 3458, 3459, 3460, 3461, 3462, 3463, 3464, 3465, 3466, 3468, 3470, 3473, 3474, 3475, 3476, 3477, 3478, 3479, 3494, 3495, 3496, 3497, 3498, 3499, 3500, 3501, 3502, 3503, 3504, 3505, 3506, 3507, 3508, 3509, 3514, 3580, 3583, 3584, 3585, 3586, 3587, 3588, 3589, 3590, 3591, 3592, 3593, 3594, 3595, 3596, 3597, 3598, 3599, 3600, 3601, 3602, 3603, 3604, 3605, 3606, 3607, 3608, 3609, 3610, 3611, 3612, 3613, 3614, 3615, 3616, 3617, 3618, 3619, 3620, 3621, 3622, 3623, 3652, 3653, 3654, 3655, 3656, 3657, 3658, 3659, 3660, 3661, 3662, 3663, 3664, 3665, 3666, 3667, 3668, 3669, 3670, 3671, 3672, 3673, 3674, 3675, 3676, 3677, 3678, 3679, 3680, 3681, 3682, 3683, 3684, 3685, 3686, 3687, 3688, 3689, 3690, 3691, 3692, 3693, 3694, 3695, 3696, 3697, 3698, 3699, 3700, 3701, 3702, 3703, 3704, 3705, 3706, 3707, 3708, 3709, 3710, 3711, 3712, 3713, 3714, 3715, 3716, 3717, 3718, 3719, 3720, 3721, 3722, 3723, 3724, 3725, 3726, 3727, 3733, 3735, 3736, 3737, 3740, 3741, 3744, 3745, 3772, 3773, 3774, 3775, 3776, 3777, 3778, 3793, 3795, 3796, 3821, 3857, 3905, 3906, 3907, 3908, 3909, 3910, 3917, 3918, 3919, 3920, 3921, 3922, 3923, 3924, 3925, 3926, 3927, 3928, 3929, 3930, 3994, 3995, 3996, 3997, 3999, 4009, 4010, 4011, 4012, 4013, 4014, 4016, 4017, 4018, 4019, 4020, 4021, 4022, 4023, 4024, 4025, 4026, 4028, 4029, 4030, 4031, 4033, 4035, 4039, 4040, 4049, 4050, 4051, 4052, 4053, 4054, 4055, 4056, 4059, 4060, 4061, 4062, 4063, 4064, 4065, 4066, 4067, 4068, 4069, 4077, 4078, 4079, 4080, 4081, 4082, 4083, 4084, 4085, 4086, 4087, 4164, 4165, 4166, 4167, 4168, 4169, 4170, 4171, 4172, 4173, 4174, 4175, 4176, 4177, 4178, 4179, 4180, 4181, 4182, 4184, 4185, 4191, 4192, 4193, 4194, 4195, 4196, 4204, 4212, 4214, 4215, 4216, 4217, 4218, 4220, 4223, 4227, 4228, 4229, 4230, 4233, 4245, 4246, 4247, 4248, 4249, 4250, 4252, 4253, 4254, 4255, 4256, 4257, 4258, 4259, 4260, 4261, 4262, 4263, 4264, 4265, 4266, 4267, 4268, 4269, 4270, 4271, 4272, 4273, 4274, 4275, 4276, 4277, 4278, 4279, 4280, 4281, 4284, 4285, 4290, 4295, 4296, 4351, 4352, 4353, 4358, 4359, 4360, 4362, 4364, 4365, 4366, 4367, 4368, 4369, 4370, 4371, 4372, 4373, 4374, 4375, 4385, 4388, 4389, 4390, 4391, 4393, 4394, 4395, 4396, 4400, 4402, 4411, 4412, 4413, 4416, 4417, 4440, 4515, 4529, 4532, 4551, 4552, 4553, 4554, 4557, 4558, 4560, 4566, 4567, 4568, 4569, 4570, 4571, 4572, 4573, 4574, 4575, 4576, 4591, 4592, 4593, 4599, 4600, 4602, 4603, 4604, 4605, 4606, 4607, 4608, 4609, 4610, 4611, 4612, 4614, 4709, 4710, 4711, 4712, 4713, 4718, 4719, 4720, 4721, 4723, 4724, 4725, 4726, 4727, 4728, 4729, 4730, 4731, 4732, 4733, 4734, 4736, 4737, 4738, 4739, 4742, 4743, 4885, 4886, 4926, 4927, 4929, 4930, 4964, 4965, 4966, 4997, 4998, 4999, 5000, 5001, 5002, 5003, 5004, 5005, 5006, 5007, 5017, 5019, 5020, 5043, 5044, 5045, 5046, 5047, 5048, 5106, 5109, 5110, 5111, 5112, 5116, 5117, 5118, 5119, 5127, 5129, 5130, 5131, 5132, 5208, 5209, 5210, 5211, 5214, 5223, 5224, 5228, 5229, 5280, 5282, 5283, 5284, 5285, 5286, 5287, 5288, 5292, 5293, 5296, 5297, 5298, 5299, 5300, 5301, 5302, 5303, 5304, 5305, 5306, 5307, 5311, 5312, 5313, 5314, 5315, 5316, 5317, 5318, 5319, 5320, 5321, 5322, 5324, 5378, 5379, 5381, 5382, 5396, 5397, 5398, 5399, 5400, 5401, 5402, 5404, 5405, 5406, 5407, 5409, 5410, 5411, 5412, 5413, 5414, 5415, 5416, 5417, 5418, 5419, 5420, 5421, 5422, 5426, 5427, 5490, 5491, 5492, 5493, 5494, 5495, 5496, 5497, 5498, 5499, 5500, 5501, 5502, 5503, 5504, 5505, 5506, 5507, 5515, 5516, 5518, 5523, 5524, 5525, 5526, 5527, 5529, 5531, 5532, 5534, 5540, 5541, 5542, 5543, 5566, 5631, 5632, 5633, 5640, 5641, 5642, 5643, 5644, 5645, 5647, 5648, 5649, 5650, 5651, 5652, 5653, 5654, 5714, 5715, 5719, 5720, 5721, 5730, 5731, 5732, 5733, 5734, 5735, 5739, 5740, 5741, 5742, 5743, 5786, 5789, 5791, 5792, 5793, 5794, 5795, 5829, 5832, 5833, 5876, 5877, 5880, 5881, 5882, 5883, 5884, 5888, 5889, 5890, 5891, 5892, 5893, 5894, 5895, 5896, 5897, 5898, 5899, 5900, 5914, 5916, 5917, 5957, 5958, 5961, 5962, 5963, 5964, 5965, 5966, 5967, 5968, 5969, 5970, 5971, 5972, 5973, 5974, 5975, 5976, 5977, 5978, 5979, 5980, 5981, 5982, 5984, 5989, 5990, 5991, 6013, 6014, 6015, 6043, 6044, 6045, 6055, 6056, 6057, 6058, 6059, 6060, 6061, 6062, 6063, 6064, 6286, 6290, 6291, 6342, 6343, 6344, 6345, 6346, 6347, 6348, 6372, 6373, 6374, 6379, 6380, 6381, 6382, 6383, 6384, 6385, 6389, 6390, 6391, 6392, 6393, 6394, 6395, 6396, 6397, 6398, 6400, 6401, 6402, 6403, 6406, 6481, 6482, 6488, 6489, 6492, 6493, 6494, 6495, 6498, 6499, 6500, 6501, 6504, 6505, 6574, 6575, 6576, 6577, 6578, 6579, 6582, 6643, 6644, 6645, 6660, 6661, 6729, 6733, 6734, 6742, 6743, 6744, 6745, 6746, 6747, 6748, 6833, 6863, 6864, 6865, 6866, 6867, 6868, 6869, 6870, 6871, 6872, 6873, 6874, 6875, 6876, 6877, 6878, 6879, 6880, 6881, 6882, 6883, 6884, 6885, 6886, 6887, 6888, 6899, 6900, 6901, 6902, 6903, 6904, 6905, 6907, 6908, 6949, 6950, 6951, 6952, 6954, 6955, 7013, 7014, 7041, 7042, 7043, 7044]
      return !tradeInProducts.includes(this.productId)
    }
  },
  methods: {
    ...mapActions(['SET_BTN_BUY_SHOW', 'SET_ACTIVE_TAB', 'SET_RECOMMENDED_PRODUCTS']),
    async isOutOfStockModalVisible () {
      if ((this.inStock || this.availableInStore) && !this.isPreorder) {
        return
      }

      // Перевіряємо чи є блок рекомендацій та чи є рекомендації для поточного товару
      // Якщо чогось з цього немає, то не відображаємо модальне вікно
      try {
        const blocks = await api.blocks.getBlocks({ uid: 'product_out_of_stock', productId: this.baseProductCode })

        if (!Array.isArray(blocks) || !blocks.length) {
          return
        }

        const recommendationBlock = blocks.find(block => block?.type === 'esputnik_recommendation')

        if (!recommendationBlock?.settings?.variant_id) {
          return
        }

        this.SET_RECOMMENDED_PRODUCTS({ ...this.recommendedProducts, title: recommendationBlock.title })

        const params = {
          variantId: recommendationBlock.settings.variant_id,
          show_out_of_stock: recommendationBlock.show_out_of_stock,
          drop_out_of_stock: recommendationBlock.drop_out_of_stock,
          productId: this.baseProductCode
        }
        EsputnikService.getRecommendations(params).then(products => {
          if (products?.length) {
            EsputnikService.sendProductImpressions({ products: products })

            const skus = products?.map(item => item.id) ?? []
            const esputnikBlockId = products[0].container_type

            if (skus.length) {
              api.blocks.getEsputnikRecommendations({
                skus,
                show_out_of_stock: params.show_out_of_stock,
                drop_out_of_stock: params.drop_out_of_stock
              })
                .then(res => {
                  if (res?.data?.length) {
                    this.SET_RECOMMENDED_PRODUCTS({ ...this.recommendedProducts,
                      data: res.data.map(item => {
                        return {
                          ...item,
                          link: item.link + '?sc_content=' + esputnikBlockId
                        }
                      })
                    })

                    this.$modal.show('out-of-stock-modal')
                  }
                })
            }
          }
        }).catch(() => {})
      } catch {}
    },
    async handleAllegroRedirect (e, link) {
      e.preventDefault()
      if (GoogleEnhancedEcommerce.isEnabled) {
        await GoogleEnhancedEcommerce.buyInAllegro()
      }
      window.open(link, '_blank', 'noopener, noreferrer')
    },
    showOrHideBtnBuy () {
      this.debounce(() => {
        this.isBtnInViewport = checkNodeVisibilityInViewPort(this.$refs.btnBuy, false)
        this.SET_BTN_BUY_SHOW(this.isBtnInViewport)
      }, 15)
    },
    goToCombinedProductsTab () {
      const data = {
        string: 'combined-products',
        top: this.isAdaptiveMode ? this.initialOffset - 40 : this.initialOffset - 50
      }

      this.SET_ACTIVE_TAB(data)
    }
  },
  async mounted () {
    await this.isOutOfStockModalVisible()
    // смотрим если ли во вьюпорте кнопка купить
    this.showOrHideBtnBuy()

    // вешаем листенер для отслеживания если ли во вьюпорте кнопка купить
    window.addEventListener('scroll', this.showOrHideBtnBuy)

    await this.$nextTick()
    // Генерируем ивент что описание отрендерено
    window.dispatchEvent(new CustomEvent('productDescriptionReady'))
  },
  beforeDestroy () {
    // удаляем листенер для отслеживания если ли во вьюпорте кнопка купить
    window.removeEventListener('scroll', this.showOrHideBtnBuy)
  }
}
</script>

<style scoped lang="sass">
.product-description-wrapper
  padding-top: 50px
  +mmax($tablet--hor)
    padding-top: 30px

.tab-description__container,
.tab-description__row
  display: flex
  align-items: flex-start
  justify-content: space-between
  position: relative
  flex-flow: column
  width: 100%

  +mmin($tablet)
    flex-flow: row wrap

.tab-description__half-wrapper
  width: 100%
  position: relative
  margin-bottom: 60px

  +mmin($tablet)
    width: calc(50% - 24px)

  &--gallery
    margin-bottom: 30px

    +mmin($tablet)
      position: sticky
      top: 150px
      margin-bottom: 60px

.tab-description__instruction
  margin-top: 60px

  +mmin($tablet)
    margin-top: 40px

.tab-description__wrapper
  width: 100%
  position: relative

  &--single
    margin: 0 auto
    max-width: 860px

  &--full
    max-width: 100%
    padding: 0

  &--mb
    margin-bottom: 30px

    +mmin($tablet)
      margin-bottom: 80px

.mt-fix
  margin-top: 30px
  +mmin($tablet)
      margin-top: 80px
.product__short-characteristics
  margin-top: 50px

.product__btns-wrap
  display: flex
  margin-bottom: 30px

  +mmin($tablet)
    margin-bottom: 40px

  &:nth-child(2)
    justify-content: space-between

.add-comment-btn
  position: absolute
  top: 7px
  right: 0

.tab-description__link
  margin-top: 50px

.product__details
  margin-top: 40px

  +mmin($tablet)
    margin-top: 30px

.product-actions
  display: flex
  align-items: center
  flex-flow: row wrap

.product-actions__btns-wrap
  display: flex
  align-self: flex-start
  width: 100%
  margin-top: 20px
  order: 2
  justify-content: space-between

  +mmin($tablet)
    min-width: 320px

  +mmin($tablet--hor)
    width: 54%
    order: initial
    margin-top: 40px
    justify-content: flex-start

  &:last-child
    justify-content: space-between
    margin-left: auto
    order: 4

    +mmin($tablet)
      justify-content: space-around

    +mmin($tablet--hor)
      width: auto
      min-width: auto
      order: initial

    +mmin(1360)
      width: 44%

.product-actions__btn
  width: 48%

  +mmin($tablet--hor)
    width: auto

  &--buy
    +mmin($tablet--hor)
      margin-right: 10px

  &--pre-order,
  &--wait-list
    width: 100%

.product-actions__btn:not(.product-actions__btn--wish-list)
  &:nth-child(2)
    margin-left: auto

.product-actions__pay-part-info
  width: 100%
  min-width: 300px
  margin-top: 40px
  order: 3

  +mmin($tablet--hor)
    width: 51%
    order: initial
    margin-top: 0
    margin-left: auto

.product-actions__price-wrap
  width: 100%
  display: flex
  justify-content: space-between
  align-items: center
  order: 1

  +mmin($tablet--hor)
    width: 100%
    flex-direction: column
    justify-content: flex-start
    align-items: flex-start
    order: initial

.product__actions__bonus-info
  +mmin($tablet--hor)
    margin-top: 20px

.product__sale
  margin-bottom: 20px

.product__sale-banner-wrap
  display: block
  width: 100%
  border-radius: 7px
  overflow: hidden

  img
    display: block
    width: 100%

.tab-description__half-wrapper--gallery .expert-callback
  max-width: 640px

::v-deep .product__rendered-block
  .product-slider__title
    font-size: 16px

    +mmin($tablet)
      font-size: 18px
.allegro-btn
  color: #333
  font-size: 14px
  line-height: 1.25
  padding: 7.5px 20px
  display: inline-flex
  border-radius: 3px
  border: 1px solid #FF2F00
  background-color: #fff
  align-items: center
  white-space: nowrap
  box-shadow: 0 0 0 #FF2F00
  transition: box-shadow 0.2s
  &:hover
    box-shadow: 0 0 3px #FF2F00
  +mmax($tablet--hor)
    width: 48%
    justify-content: center
  +mmax($tablet)
    padding: 9.5px
  svg
    margin-left: 5px
</style>
